export type PutDataKindResponse = {};
